import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";
import moment from "moment";
import Modal from "react-modal";
import SimpleMap from "../../../components/gmaps";
import Select from "react-select";

const ReturnInvoiceForm = (props) => {
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "10%",
      left: "20%",
      borderRadius: "5px",
      maxWidth: "850px",
      maxHeight: "auto",
      height: "500px",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };
  const frmRef = useRef({});
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);

  const bankRef = useRef({});
  const [bankClose, setBankClose] = useState(false);
  const [bankDetails, setBankDetails] = useState([]);

  const [salesData, setSalesData] = useState("");
  const [returnData, setReturnData] = useState([]);
  const [filteredData, setFilterData] = useState([]);
  const [data, setData] = useState();
  const [taxs, setTaxs] = useState([]);
  const [taxId, setTaxId] = useState();

  const [entryLatLong, setEntryLatLong] = useState({
    lat: "",
    lng: "",
  });

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;
        //console.log(lat, long);
        setEntryLatLong({ lat, lng });
      },
      (error) => {
        console.error(error);
      }
    );
  }, []);

  const { sendRequest: getTaxs } = useHttp();

  useEffect(() => {
    getTaxs(
      {
        url: `/api/tax/`,
      },
      (res) => {
        if (res) {
          // //console.log(res);
          setTaxs(res);
        }
      }
    );
  }, [getTaxs]);

  const { sendRequest: getSalesOrder } = useHttp();

  useEffect(() => {
    getSalesOrder(
      {
        url: `/api/salesOrder/?orgId=${localStorage.getItem(
          "orgId"
        )}&regionId=2`,
      },
      (res) => {
        if (res) {
          // //console.log(res);
          setSalesData(res);
        }
      }
    );
  }, [getSalesOrder]);

  const { sendRequest: getSalesReturn } = useHttp();

  useEffect(() => {
    getSalesReturn(
      {
        url: `/api/salesReturn/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setReturnData(res);
          //console.log("data", res);
        }
      }
    );
  }, [getSalesReturn]);

  const handleOrderIdChange = (e) => {
    const id = e.target.value;

    //console.log(id);

    if (id) {
      const filterReturnData = returnData.filter(
        (item) => item.salesOrderCode == id
      );

      //console.log(filterReturnData);
      setFilterData(filterReturnData);
    }
  };

  const handleReturnIdChange = (e) => {
    const id = e.target.value;
    console.log(id);
    if (id) {
      const data = filteredData.filter((item) => item.salesReturnId == id);

      frmRef.current.customer_id.value = data && data[0].customerId;
      frmRef.current.delivery_date.value = moment(
        data && data[0].estimatedDeliveryDate,
        "DD-MM-YYYY"
      ).format("YYYY-MM-DD");
      frmRef.current.dnd_id.value = data && data[0].dndId;
      frmRef.current.contact_person_name.value =
        data && data[0].customerContactPersonName;
      //setProductDetails(data && data[0].salesReturnProducts);
      frmRef.current.total_amt.value = data && data[0].totalAmount;
      frmRef.current.total_cost.value = data && data[0].totalReturnCostValue;
      frmRef.current.amt_chargeable.value = data && data[0].amountChargeable;
      frmRef.current.tax_amt.value = data && data[0].taxAmount;
      frmRef.current.reason.value = data && data[0].reasonOfItem;
      frmRef.current.condition.value = data && data[0].conditionOfItem;
      frmRef.current.remark.value = data && data[0].remark;

      frmRef.current.tax.value = data && data[0].taxId;

      const custId = parseInt(data && data[0].customerId);

      loadCustomerData(custId);

      setProductDetails(
        data &&
          data[0].salesReturnProducts.map((x) => ({
            ...x,
            salesReturnInvoiceProductId: generateId() + 1,

            salesReturnInvoiceQuantity: parseInt(x.salesReturnQuantity),
          }))
      );
    }
  };

  const { sendRequest: getCustomer } = useHttp();

  const loadCustomerData = (id) => {
    getCustomer(
      {
        url: `/api/customer/?orgId=${localStorage.getItem(
          "orgId"
        )}&customerId=${id}`,
      },
      (res) => {
        if (res) {
          //console.log(res);

          frmRef.current.customer_name.value = res && res.name;
          frmRef.current.email.value = res && res.emailId;
          frmRef.current.work_contact.value = res && res.workContactNumber;
          frmRef.current.contact_person_name.value =
            res && res.contactPersonDetails[0].name;
        }
      }
    );
  };

  function generateId() {
    const currentDate = moment().format("YYYYMMDD");
    const currentTime = moment().format("HHmmss");
    return `${currentDate}${currentTime}`;
  }

  const { sendRequest: postGoodsReturn } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();
    const data = {
      createdBy: parseInt(localStorage.getItem("id")),
      salesInvoiceReturnDetails: [
        {
          salesReturnInvoiceId: generateId(),

          date: moment(frmRef.current.date.value).format("DD/MM/YYYY"),
          salesReturnId: frmRef.current.sales_return_id.value,
          salesInvoiceReturnProducts: productDetails,

          totalAmount: frmRef.current.total_amt.value,
          taxId: frmRef.current.tax.value,
          taxAmount: frmRef.current.tax_amt.value,
          totalReturnCostValue: frmRef.current.total_cost.value,

          amountChargeable: 0,
          conditionOfItem: frmRef.current.condition.value,
          reasonOfItem: frmRef.current.reason.value,
          remark: frmRef.current.remark.value,
          status: 1,

          orgId: parseInt(localStorage.getItem("orgId")),
          createdDate: moment().format("DD/MM/YYYY hh:mm:ss"),
          entryTime: moment().format("HH:mm:ss"),
          entryLatLong,
          createdBy: parseInt(localStorage.getItem("id")),
        },
      ],
    };
    //console.log(data);
    postGoodsReturn(
      {
        url: "/api/salesInvoiceReturn/",
        method: "POST",
        body: data,
      },
      (data) => {
        //console.log(data);
        toast.success("Sales Invoice Done Successfully");
        props.addForm(false);
      },
      (err) => {
        //console.log(err);
        toast.error("Sales Invoice Failed");
      }
    );
  };

  // bank details
  const submitBankDetails = (e) => {
    e.preventDefault();
    setBankDetails((x) => [
      ...x,
      {
        srno:
          bankDetails.length > 0
            ? bankDetails[bankDetails.length - 1].srno + 1
            : 1,

        accountNumber: bankRef.current.account_number.value,
        accountHolderName: bankRef.current.acc_holder_name.value,
        ifscCode: bankRef.current.ifsc_code.value,
      },
    ]);

    //console.log(bankDetails);
  };
  const handleDeleteBank = (index, e) => {
    setBankDetails(bankDetails.filter((v, i) => i !== index));
  };
  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Sales Return Invoice Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"date"}> {"Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"sales_order_id"}>
                        {" "}
                        {"Sales order id"}
                      </label>
                      <select
                        id="sales_order_id"
                        className="form-control"
                        ref={(el) => (frmRef.current["sales_order_id"] = el)}
                        onChange={handleOrderIdChange}
                      >
                        <option value="">Select</option>
                        {salesData &&
                          salesData.map((x) => (
                            <option
                              key={x.salesOrderId}
                              value={x.salesOrderCode}
                            >
                              {x.salesOrderCode}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"sales_return_id"}>
                        {"Sales Return id"}
                      </label>
                      <select
                        id="sales_return_id"
                        className="form-control"
                        ref={(el) => (frmRef.current["sales_return_id"] = el)}
                        onChange={handleReturnIdChange}
                        required
                      >
                        <option value="">Select</option>
                        {filteredData &&
                          filteredData.map((x) => (
                            <option
                              key={x.salesOrderId}
                              value={x.salesReturnId}
                            >
                              {x.docNo}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"dnd_id"}>{"DnD id"}</label>
                      <input
                        type={"text"}
                        id={"dnd_id"}
                        required
                        ref={(el) => (frmRef.current["dnd_id"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"delivery_date"}>
                        {" "}
                        {"Delivery Date"}
                      </label>
                      <input
                        type={"date"}
                        id={"delivery_date"}
                        required
                        ref={(el) => (frmRef.current["delivery_date"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"contact_person_name"}>
                        {"Contact Person Name"}
                      </label>
                      <input
                        type={"text"}
                        id={"contact_person_name"}
                        required
                        ref={(el) =>
                          (frmRef.current["contact_person_name"] = el)
                        }
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"customer_name"}>
                        {" "}
                        {"Customer Name"}
                      </label>
                      <input
                        type={"text"}
                        id={"customer_name"}
                        required
                        ref={(el) => (frmRef.current["customer_name"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"customer_id"}> {"Customer id"}</label>
                      <input
                        type={"text"}
                        id={"customer_id"}
                        required
                        ref={(el) => (frmRef.current["customer_id"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"email"}> {"Email Id"}</label>
                      <input
                        type={"email"}
                        id={"email"}
                        required
                        ref={(el) => (frmRef.current["email"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"work_contact"}>{"Contact Number"}</label>
                      <input
                        type={"text"}
                        id={"work_contact"}
                        required
                        ref={(el) => (frmRef.current["work_contact"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"product_details"}>
                        {" "}
                        {"Product Details"}
                      </label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type={"button"}
                        id={"product_details"}
                        autoComplete="off"
                        ref={(el) => (frmRef.current["product_details"] = el)}
                        className="btn btn-sm btn-success"
                        onClick={() => {
                          //    productDetails&& setProductDetails((items) => items.filter((x) => x.isSave));
                          setClose(true);
                        }}
                      >
                        View
                      </button>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"tax"}> {"Tax"}</label>
                      <select
                        id="tax"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["tax"] = el)}
                        disabled
                      >
                        <option value="">Select</option>
                        {taxs &&
                          taxs.map((x) => (
                            <option key={x.taxId} value={x.taxId}>
                              {x.taxName}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"tax_amt"}>{"Tax Amount"}</label>
                      <input
                        type={"text"}
                        id={"tax_amt"}
                        required
                        ref={(el) => (frmRef.current["tax_amt"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"total_amt"}>{"Total Amount"}</label>
                      <input
                        type={"text"}
                        id={"total_amt"}
                        required
                        ref={(el) => (frmRef.current["total_amt"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"total_cost"}>
                        {"Total Purchase Cost/Value"}
                      </label>
                      <input
                        type={"text"}
                        id={"total_cost"}
                        required
                        ref={(el) => (frmRef.current["total_cost"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"condition"}>
                        {" "}
                        {"Condition of Item"}
                      </label>
                      <select
                        id="condition"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["condition"] = el)}
                      >
                        <option value="Good">Good</option>
                        <option value="Moderate">Moderate</option>
                        <option value="Bad">Bad</option>
                        <option value="Very Bad">Very Bad</option>
                      </select>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-3">
                      <label htmlFor={"reason"}>{"Reason of Return"}</label>
                      <select
                        id="reason"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["reason"] = el)}
                      >
                        <option value="Defective">Defective</option>
                        <option value="Packaging issue">Packaging issue</option>
                        <option value="Quality Issue">Quality Issue</option>
                        <option value="Other(Input)">Other(Input)</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"amt_chargeable"}>
                        {" "}
                        {"Amount Chargeable"}
                      </label>
                      <input
                        type={"text"}
                        id={"amt_chargeable"}
                        required
                        ref={(el) => (frmRef.current["amt_chargeable"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        required
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className=" text-right">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
      {close && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Product Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <table className="table table-bordered table-sm text-center table-responsive">
            <thead>
              <tr className="">
                <th>Sr. No</th>
                <th>Item Id</th>
                <th>Item Description</th>
                <th>Item Type</th>
                <th>Item Category/Variety</th>
                <th>Item Unit Price</th>
                <th>Rate</th>
                <th>Item Quantity</th>
                <th>Sub Total</th>
                <th>Discount</th>
                <th>Discount Amount</th>
                <th>Unit</th>
                <th>Amount</th>
              </tr>
            </thead>

            <tbody>
              {productDetails &&
                productDetails.map((itm, i) => {
                  return (
                    <tr key={i}>
                      <td>{itm.lineSrNo}</td>
                      <td>{itm.productId}</td>
                      <td>{itm.productName}</td>
                      <td>{itm.itemType}</td>
                      <td>{itm.productSubTypeName}</td>
                      <td>{itm.itemUnitPrice}</td>
                      <td>{itm.rate}</td>
                      <td>{itm.salesReturnQuantity}</td>
                      <td>{itm.subTotalAmount}</td>
                      <td>{itm.discount}</td>
                      <td>{itm.discountAmount}</td>
                      <td>{itm.unitAbbreviation}</td>
                      <td>{itm.totalLineAmount}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
          <hr />
          <div className="text-center">
            <button
              className="btn btn-sm btn-primary"
              onClick={() => {
                setClose(false);
              }}
            >
              Close
            </button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default ReturnInvoiceForm;
